import avatar1 from '@/assets/images/user-avatar-1.webp';
import avatar2 from '@/assets/images/user-avatar-2.webp';
import avatar3 from '@/assets/images/user-avatar-3.webp';
import avatar4 from '@/assets/images/user-avatar-4.webp';

const AVATARS = [avatar1, avatar2, avatar3, avatar4];

/** Deterministic placeholder avatar for a customer (stable across renders, keyed on a customer
 *  identifier such as name) until the backend supplies a real avatar URL. Shared by the payments
 *  ledger and the customer listing so both surfaces render the same dynamic avatar for a person. */
export function customerAvatar(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) | 0;
  }
  return AVATARS[Math.abs(hash) % AVATARS.length];
}
